var parent = require('../../es/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/sort.js
// module id = 1119
// module chunks = 0